export const VENEER_PRIMARY_APPEARANCE = 'primary'
export const VENEER_SECONDARY_APPEARANCE = 'secondary'
export const VENEER_TERTIARY_APPEARANCE = 'ghost'
export const VENEER_WHITE = 'colorWhite'
export const VENEER_HP_BLUE_6 = 'colorHpBlue6'
export const CARD_TYPE_BUSINESS = 'Business'
export const CONNECTION_ETHERNET = 'ethernet'
export const CONNECTION_WIRELESS = 'wireless'
export const UNSUPPORTED_BROWSER = 'unsupported_browser'
export const EMPTY_ARROW_FUNCTION = () => null

export const SECONDARY = 'SECONDARY'
export const YETI_PROGRAM_ID = 'YETI'

export const debounceDelay = 500

export const UserOs = {
  ios: 'ios',
  android: 'android',
  linux: 'linux',
  mac: 'mac',
  windows: 'windows',
  chrome: 'chrome',
  harmony: 'harmony',
  unknown: 'unknown'
}

export const PrinterFamily = {
  FLOWERS_CHERRY: 'flowers_cherry',
  FLOWERS_LOTUS: 'flowers_lotus',
  KEBIN_EDDINGTON: 'kebin_eddington',
  KEBIN_ELION: 'kebin_elion',
  MANHATTAN_BASE: 'manhattan_base',
  MANHATTAN_HI: 'manhattan_hi',
  MARCONI_BASE: 'marconi_base',
  MARCONI_HI: 'marconi_hi',
  MALBEC: 'malbec',
  MORETO_BASE: 'moreto_base',
  MORETO_HI: 'moreto_hi',
  NOVELLI: 'novelli',
  SAYAN: 'sayan',
  TACCOLA: 'taccola',
  LEO_WL: 'leo_wl',
  LEO_SF: 'leo_sf',
  TRILLIUM_BASE: 'trillium_base',
  TRILLIUM_PLUS: 'trillium_plus',
  VICTORIA_BASE: 'victoria_base',
  VICTORIA_PLUS: 'victoria_plus',
  EUTHENIA_SFP: 'euthenia_sfp',
  EUTHENIA_MFP: 'euthenia_mfp',
  SELENE_SFP: 'selene_sfp',
  SELENE_MFP: 'selene_mfp',
  ULYSSES_SFP: 'ulysses_sfp',
  ULYSSES_MFP: 'ulysses_mfp',
  ZELUS_SFP: 'zelus_sfp',
  ZELUS_MFP: 'zelus_mfp',
  BASIC_DRIVER: 'basic_driver',
  MAC_UNSUPPORTED: 'mac_unsupported',
  EASY_START: 'easy_start',
  USB_ONLY: 'usb_only',
  INSTALL_HP_APP: 'install_hp_app',
  LASERJET: 'laserjet',
  MAC: 'MAC',
  PAAS: 'paas',
  GREENFIELD_DW: 'greenfield_dw',
  GREENFIELD_D: 'greenfield_d',
  SUNSPEAR_SDN: 'sunspear_sdn',
  SUNSPEAR_SDW: 'sunspear_sdw',
  SUNSPEAR_DW: 'sunspear_dw',
  SUNSPEAR_D: 'sunspear_d',
  LOCHSA: 'lochsa',
  YOSHINO: 'yoshino',
  HULK: 'hulk',
  STORM: 'storm',
  LEBI_WL: 'lebi_wl',
  LEBI_SF: 'lebi_sf',
  LEBI_AIO: 'lebi_aio'
}

export const ConnectionTypes = {
  skip_internet: 'skip-internet',
  usb: 'usb'
}

// Keeping these in constants as it allows the hook to be mocked more simply
export const USE_CONTENTSTACK_QUERY_TYPES = {
  DERIVATIVE_NAME: 'derivative_name',
  INSTRUCTION: 'instruction',
  CHECKLIST: 'checklist',
  SUPPORTED_PRODUCTS: 'supported_products',
  OPERATING_SYSTEM: 'operating_system',
  SIDEBAR_TYPE: 'sidebar_type'
}

export const ContentStackStacks = {
  pie: {
    api_key: 'bltbd278b8fc62d8a81',
    delivery_token: 'csf87a38deb22ccca3b00c5e6e',
    env_name: 'pie',
    enable_live_preview: true,
    management_token: 'csf6642729128c250b98bcf981'
  },
  stage: {
    api_key: 'bltbd278b8fc62d8a81',
    delivery_token: 'csc00de34ed25342b79c8c67ee',
    env_name: 'stage'
  },
  prod: {
    api_key: 'bltbd278b8fc62d8a81',
    delivery_token: 'cs5dd29cc573471aaa1cf10a57',
    env_name: 'prod'
  }
}

export const UnsupportedCmsIds = {
  [UserOs.chrome]: 'unsupported_os_chromebook',
  [UserOs.windows]: 'unsupported_os_general',
  [UserOs.linux]: 'unsupported_os_general_browser',
  [UserOs.mac]: 'unsupported_os_macos',
  [UserOs.harmony]: 'unsupported_os_general',
  [UserOs.unknown]: 'unsupported_os_general',
  unsupported_browser: 'unsupported_os_general_browser'
}

export const ContentStackTypes = {
  simple_landing_page: {
    content_type_uid: 'simple_landing_page'
  },
  simple_landing_page_paas: {
    content_type_uid: 'simple_landing_page',
    entry_uid: 'bltafca1aef49aed66b'
  },
  simple_landing_page_usb_only: {
    content_type_uid: 'simple_landing_page',
    entry_uid: 'blta535f66811128552'
  },
  simple_landing_page_install_hp_app: {
    content_type_uid: 'simple_landing_page',
    entry_uid: 'blt1396554bd7cffe0c'
  },
  simple_landing_page_search_mobile: {
    content_type_uid: 'simple_landing_page',
    entry_uid: 'bltd2b70aaf21a580e1'
  },
  simple_landing_page_laserjet: {
    content_type_uid: 'simple_landing_page',
    entry_uid: 'bltb944264d38ebc0fc'
  },
  simple_landing_page_search_mac: {
    content_type_uid: 'simple_landing_page',
    entry_uid: 'bltc7a91fc09deb6af2'
  },
  simple_landing_page_device_not_listed: {
    content_type_uid: 'simple_landing_page',
    entry_uid: 'bltc689f7787e5a4df4'
  },
  simple_landing_page_search_unsupported_os: {
    content_type_uid: 'simple_landing_page',
    entry_uid: 'blt43927e17a76649c8'
  },
  simple_landing_page_easy_start: {
    content_type_uid: 'simple_landing_page',
    entry_uid: 'blt45766a8582f60bee'
  },
  simple_landing_page_basic_driver: {
    content_type_uid: 'simple_landing_page',
    entry_uid: 'blt775e2d549f5c756e'
  },
  simple_landing_page_get_software: {
    content_type_uid: 'simple_landing_page',
    entry_uid: 'blt402876a0dd0f732d'
  },
  printer_specific_landing_page: {
    content_type_uid: 'printer_specific_landing_page'
  },
  support_callout: {
    content_type_uid: 'support_callout'
  },
  china_hp_app: {
    content_type_uid: 'china_hp_app',
    entry_uid: 'blt4504639073ec9a57'
  },
  china_hp_app_smb_portal: {
    content_type_uid: 'china_hp_app',
    entry_uid: 'bltaa9eaec366c50a6d'
  },
  china_hp_software: {
    content_type_uid: 'china_hp_software',
    entry_uid: 'blta79637aae4720b36'
  },
  tde_layout: {
    content_type_uid: 'tde_layout',
    entry_uid: 'bltbee092510ffe4cac'
  },
  language_selector: {
    entry_uid: 'blt1ab3cfbc5e7e76af',
    content_type_uid: 'language_selector'
  },
  page_not_found: {
    entry_uid: 'bltcdd5d2848943188a',
    content_type_uid: 'page_not_found'
  },
  carousel_instruction: {
    content_type_uid: 'instruction_carousel'
  },
  delta_access_page: {
    entry_uid: 'blt28d0b7352883933f',
    content_type_uid: 'delta_access_page'
  },
  connect_printer_to_network: {
    content_type_uid: 'connect_printer_to_network'
  },
  printer_use_choice: {
    entry_uid: 'blt7c78ca69c1425da8',
    content_type_uid: 'printer_use_choice'
  },
  setup_checklist: {
    content_type_uid: 'setup_checklist'
  },
  subtab_layout: {
    content_type_uid: 'subtab_layout'
  },
  finish_setup_business: {
    entry_uid: 'blte03f4891540bafbe',
    content_type_uid: 'generic_card'
  },
  wifi_setup_modal: {
    content_type_uid: 'modal'
  },
  use_offline_modal_desktop: {
    entry_uid: 'blta631a580608b679e',
    content_type_uid: 'modal'
  },
  use_offline_modal_mobile: {
    entry_uid: 'bltd1c5d636c3cb5c35',
    content_type_uid: 'modal'
  },
  connect_usb: {
    content_type_uid: 'generic_card'
  },
  [UnsupportedCmsIds[UserOs.chrome]]: {
    entry_uid: 'blt403522a48068a1cc',
    content_type_uid: 'unsupported_os'
  },
  unsupported_install_qrcode: {
    entry_uid: 'bltb1e8a72253e869bc',
    content_type_uid: 'unsupported_os'
  },
  [UnsupportedCmsIds[UserOs.windows]]: {
    entry_uid: 'blt1157be8346ec311e',
    content_type_uid: 'unsupported_os'
  },
  [UnsupportedCmsIds[UserOs.mac]]: {
    entry_uid: 'blt166409b88c399537',
    content_type_uid: 'unsupported_os'
  },
  [UnsupportedCmsIds[UserOs.linux]]: {
    entry_uid: 'blt945c6f58cc088be8',
    content_type_uid: 'unsupported_os'
  },
  [UnsupportedCmsIds.unsupported_browser]: {
    entry_uid: 'blt547ccc8abb4cf086',
    content_type_uid: 'unsupported_os'
  },
  unsupported_os_trillium: {
    entry_uid: 'blt18d7b5710e7a8cea',
    content_type_uid: 'unsupported_os'
  },
  driver_download: {
    entry_uid: 'bltcdae44c026c955cd',
    content_type_uid: 'generic_card'
  },
  driver_download_intranet: {
    entry_uid: 'bltfe7c5b6bb3fcbc94',
    content_type_uid: 'generic_card'
  },
  driver_not_found: {
    entry_uid: 'blt2acd3c2edc90da02',
    content_type_uid: 'generic_card'
  },
  download_started: {
    entry_uid: 'bltdacc466707ebcec8',
    content_type_uid: 'generic_card'
  },
  select_usb_on_display: {
    content_type_uid: 'generic_card'
  },
  hp_software: {
    entry_uid: 'bltc94810e34efc22c7',
    content_type_uid: 'hp_software'
  },
  hp_software_mobile: {
    entry_uid: 'blt42cd4e1a862e7387',
    content_type_uid: 'hp_software'
  },
  hp_software_skyline_mobile: {
    entry_uid: 'bltc7be8b67135ee802',
    content_type_uid: 'hp_software'
  },
  external_links: {
    entry_uid: 'bltc022dbc8cc109a41',
    content_type_uid: 'external_links'
  },
  trouble_installing_modal_desktop_win: {
    entry_uid: 'blte52cca27a8c8ba63',
    content_type_uid: 'modal'
  },
  trouble_installing_modal_desktop_mac: {
    entry_uid: 'blt3ac63b0954400607',
    content_type_uid: 'modal'
  },
  trouble_installing_modal_mobile: {
    entry_uid: 'bltf992f5c1c77da8d9',
    content_type_uid: 'modal'
  },
  printer_not_listed_modal_mac: {
    entry_uid: 'bltdc183fb138776151',
    content_type_uid: 'modal'
  },
  hp_smart_features_modal: {
    content_type_uid: 'modal'
  },
  unsupported_os_modal: {
    entry_uid: 'blt8f2c851753d68729',
    content_type_uid: 'modal'
  },
  skip_internet_connection: {
    entry_uid: 'blt8a0443601036eb3c',
    content_type_uid: 'generic_card'
  },
  start_airprint: {
    entry_uid: 'blt7b5b730b6a85a0bf',
    content_type_uid: 'generic_card'
  },
  start_printing_mobile: {
    entry_uid: 'blt046ed8a63b4cce15',
    content_type_uid: 'start_printing_mobile'
  },
  tab_definition: {
    content_type_uid: 'tab_definition'
  },
  hp_support: {
    entry_uid: 'blt9df9361083da4e77',
    content_type_uid: 'hp_support'
  },
  learn_printer_features: {
    entry_uid: 'blt93990b2682f317fb',
    content_type_uid: 'subtab_layout'
  },
  switch_to_mobile: {
    content_type_uid: 'modal'
  },
  switch_to_mobile_general: {
    entry_uid: 'blt3e3ae6391458fbd8',
    content_type_uid: 'modal'
  },
  configuration_definitions: {
    content_type_uid: 'configuration_definitions',
    definitions: {
      friendly_url: 'friendly_url'
    }
  },
  search_landing_page: {
    content_type_uid: 'search_page',
    entry_uid: 'bltd7c297d9d9841a86'
  },
  unable_to_find_landing_page: {
    content_type_uid: 'search_page',
    entry_uid: 'blt77aaa365dfe1acfd'
  },
  carousel_modal_wheres_product_name: {
    content_type_uid: 'carousel_modal',
    entry_uid: 'blt9294a156550dca4e'
  },
  modal_scanning_features_notice: {
    content_type_uid: 'modal',
    entry_uid: 'blt3c5446324df01c76'
  },
  modal_alignment_help: {
    content_type_uid: 'modal',
    entry_uid: 'blt4925232d606c8a00'
  },
  printer_images: {
    content_type_uid: 'printer_images',
    entry_uid: 'blt507bf3bf729fb389'
  }
}

export const ContentStackGlobalFields = {
  derivative_names: 'derivative_names'
}

export const Instructions = {
  install_ink: 'install-ink',
  load_paper: 'load-paper',
  alignment: 'alignment',
  power_on: 'power-on',
  hp_software: 'hp-software',
  purger: 'purger',
  printheads: 'printheads',
  install_hp_software: 'install-hp-software'
}

export const Paths = {
  home: '/:sku',
  country_language: '/country-language',
  load_paper: '/load-paper',
  install_ink: '/install-ink',
  alignment: '/alignment',
  connect_printer_to_network: '/printer-network',
  set_up_checklist: '/setup-checklist',
  printer_use_choice: '/printer-use',
  setup_checklist: '/setup-checklist',
  connect_usb: '/connect-usb',
  unsupported_os: '/unsupported-os',
  driver_download: '/driver-download',
  driver_after: '/driver-after',
  select_usb_on_display: '/usb-printer-display',
  paas: '/paas',
  not_found: '/not-found',
  hp_software: '/hp-software',
  hp_software_trillium: '/hp-software-trillium',
  finish_setup_business: '/finish-setup-business',
  skip_internet_connection: '/skip-internet-connection',
  start_airprint: '/start-airprint',
  start_printing_mobile: '/start-printing-mobile',
  install: '/install',
  install_unsupported_os: '/install-unsupported-os',
  search: '/',
  basicDriver: '/basicDriver',
  device_not_listed: '/device-not-listed',
  usb_only: '/usb-only',
  hp_app: '/hp-app'
}

export const Urls = {
  hp123: 'https://123.hp.com/',
  hpPlus: 'https://hp.com/plus/',
  instantInk: 'https://instantink.com/',
  swls: (sku) =>
    `https://h20614.www2.hp.com/ediags/solutions/software/v3?client=PSW&os=Windows+NT+10.0&ProductNumber=${sku}`,
  // No-SKU endpoints for driver setup per OS (Windows/Mac only)
  swlsNoSku: (os, easystartpro = false) => {
    if (os === UserOs.mac) {
      if (easystartpro) {
        return 'https://h20614.www2.hp.com/ediags/solutions/software/v3?client=PSW&ModelName=EasyStartPro&os=MacOS+10.14'
      } else {
        return 'https://h20614.www2.hp.com/ediags/solutions/software/v3?client=PSW&ModelName=MACSWSETUP&os=MacOS+10.14'
      }
    }
    if (os === UserOs.windows) {
      return 'https://h20614.www2.hp.com/ediags/solutions/software/v3?client=PSW&ModelName=WINSWSETUP&os=Windows+NT+10.0'
    }
    return null
  }
}

export const LocalStoreKeys = {
  user: 'user',
  selectedAccordionItems: 'selectedAccordionItems'
}

export const DriverTypes = {
  win_sw_setup_integrated: 'WINSWSETUPINTEGRATED',
  win_sw_setup: 'WINSWSETUP',
  basic_x64: 'BASICX64',
  basic_x64_uss: 'USS_BASICX64',
  basic_x86: 'BASICX86',
  basic_x86_uss: 'USS_BASICX86',
  fullkarnak: 'FULLKARNAK',
  mac_sw_setup: 'MACSWSETUP',
  mac_easy_start_pro: 'ESSENTIAL-REQUIRED'
}

export const GenericCardTypes = {
  connect_usb: 'CONNECT_USB',
  driver_not_found: 'DRIVER_NOT_FOUND',
  finish_setup: 'FINISH_SETUP',
  install_driver: 'INSTALL_DRIVER',
  install_driver_intranet: 'INSTALL_DRIVER_INTRANET',
  select_usb_display: 'SELECT_USB_DISPLAY',
  skip_internet_connection: 'SKIP_INTERNET_CONNECTION',
  start_airprint: 'START_AIRPRINT'
}

export const ModalTypes = {
  use_offline: 'USE_OFFLINE',
  wifi_setup: 'WIFI_SETUP',
  trouble_installing: 'TROUBLE_INSTALLING',
  scanning_features_notice: 'SCANNING_FEATURES_NOTICE',
  switch_to_mobile: 'SWITCH_TO_MOBILE',
  os_unsupported: 'OS_UNSUPPORTED',
  printer_not_listed: 'PRINTER_NOT_LISTED',
  hp_smart_features: 'HP_SMART_FEATURES'
}

export const FeatureFlagKeys = {
  betaAccessCode: 'olex-release-traffic-director-beta-access-code',
  saltString: 'olex-traffic-director-salt',
  deltaPageDerivatives: 'olex-traffic-director-delta-page-derivatives',
  migration123: 'olex-traffic-director-123migration',
  hpSupportResolutionWithPswApi: 'olex-hp-support-resolution-with-psw-api',
  supportCalloutMapping: 'olex-support-callout-mapping',
  olexPswHpxOffer: 'olex-psw-hpx-offer'
}

export const ConfigurationDefinitionsKeys = {
  compatibilityDefinitions: 'compatibility',
  skuWithoutUsbDefinition: 'sku_without_usb',
  skuWithUsbDisclaimer: 'skus_with_usb_disclaimer',
  hpSupportLocaleMap: 'hp_support_locale_map'
}

export const Errors = {
  cms_page_error: 'cms_page_error'
}

export const ShellEventKeys = {
  hp_app_store_clicked: 'hp-app-store-clicked'
}
